import { toast } from '@hivebrite/design-system/Toast';

import { type HandleDataParams } from '../types';
import { FeedType } from '../types';

export const handleData =
  ({
    isEditingPost,
    onCloseModal,
    onCreate,
    onUpdate,
    topic,
    type,
  }: HandleDataParams) =>
  ({ data }) => {
    if (isEditingPost) {
      toast.success(__('Successfully updated'));
      if (onUpdate) {
        /** On My Groups feed, each topic post handles its own topic data */
        const updatedValue =
          type === FeedType.MY_GROUPS_FEED_TYPE
            ? { ...data?.topic_post, topic }
            : data?.topic_post;

        onUpdate(data?.feed_post || updatedValue);
      }
    } else {
      toast.success(__('Successfully created'));
      if (onCreate) {
        onCreate(data?.feed_post || data?.topic_post);
      }
    }

    /*
      If the `isOpen` prop is used as the only way to close
      the dialog (instead of something like `isOpen && <Modal />`), then
      this hack can be safely removed.
     */
    if (typeof window?.ReactNativeWebView?.postMessage === 'function') {
      window.ReactNativeWebView.postMessage('dialogIsClosed');
    }

    onCloseModal();
  };
